import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Loader2, Images } from "lucide-react";
import { API, http, errMsg } from "../../../lib/api";

export const CoverArt = ({ kit, c, testId }) => (
  <div data-testid={testId} className="flex items-center justify-center p-6 min-h-[180px]" style={{ background: c.dark }}>
    {kit.images?.cover
      ? <img src={`${API}/kits/${kit.id}/images/cover/file?v=${kit.images.cover.id}`} alt={`${kit.destination} cover`} className="max-h-[360px] w-auto object-contain border border-white/20" />
      : <div className="font-display text-2xl text-white/80 text-center">{kit.destination.split(",")[0]}</div>}
  </div>
);

export const IllustrationsPanel = ({ kit, c, reload, onOpen }) => {
  const [busy, setBusy] = useState(false);
  const n = kit.summary?.images || 0;
  const slots = kit.photo_slots?.length || 0;
  const redraw = async () => {
    setBusy(true);
    try { await http.post(`/kits/${kit.id}/images/cover/generate`, {}, { timeout: 120000 }); toast.success("Cover redrawn"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <section data-testid="illustrations-panel" className="rise grid md:grid-cols-[260px_1fr] border border-stone-200 bg-white mb-8">
      <CoverArt kit={kit} c={c} testId="illustrations-cover" />
      <div className="p-6">
        <div className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-stone-400">Illustrations</div>
        <p data-testid="illustrations-count" className="text-sm text-[#2B2A26] mt-2">{n} of {slots} images: the cover plus one for each chapter opener. The PDF stays photo-free; images are used for the app, store and Instagram.</p>
        <div className="flex flex-wrap gap-2 mt-4">
          <button data-testid="redraw-cover-button" onClick={redraw} disabled={busy} className="inline-flex items-center gap-2 border border-stone-300 px-4 py-2 text-sm text-[#2B2A26] hover:bg-stone-50 disabled:opacity-40">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Pencil size={14} />} Redraw cover
          </button>
          <button data-testid="open-photography-button" onClick={onOpen} className="inline-flex items-center gap-2 border border-stone-300 px-4 py-2 text-sm text-[#2B2A26] hover:bg-stone-50">
            <Images size={14} /> All illustrations
          </button>
        </div>
      </div>
    </section>
  );
};
